import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BehaviorSubject, Subject } from "rxjs";
import { ApiRoutes } from "src/app/services/apiroutes";
import { RequestApiService } from "src/app/services/domain_code/request-api.service";
import { MyOrdersService } from "../my-orders-table/my-orders-table.service";
import { RequestAlterModel } from "./request-alter.model";
import { BackendListModel } from "src/app/models/common/list.model";
import { DomainCode } from "src/app/models/common/model";

@Component({
    selector: 'logzy-request-alter-form',
    templateUrl: './request-alter-form.component.html',
    styleUrls: ['./request-alter-form.component.scss']
})

export class RequestAlterFormComponent implements OnInit {

    @Input()
    refreshRequestForm = new Subject();

    requestUpdate = new BehaviorSubject(null);

    requirementObj;

    requestObj: RequestAlterModel;
    modelService: RequestApiService;
    leadSourceList: BackendListModel<DomainCode>;
    portUrl = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;

    superLocationSourceLabel: string;
    superLocationDestinationLabel: string;
    @Output() close: EventEmitter<any> = new EventEmitter();

    constructor(public requestService: RequestApiService,
        private myOrderService: MyOrdersService,
        private snackBar: MatSnackBar,) {
    }

    ngOnInit() {
        this.requestObj = new RequestAlterModel();
        this.modelService = this.requestService;
        this.refreshRequestForm.subscribe(item => {
            if (item != null) {
                this.requestObj.setPayload(item)
                this.requirementObj = item;
                this.getLocationLabel(item);
                this.requestUpdate.next(item);
            } else {
                this.requestObj = new RequestAlterModel();
                this.requirementObj = item;
                this.requestUpdate.next(item);
            }
        })
        console.log("selectedRequest Check", this.requestService.selectedRequest);
    }

    saveRequestLocation() {
        if (!this.validatePorts()) {
            return;
        }
        this.requestService.updateRequestLocations(this.modelService.selectedRequest.id, this.getIdFromObjList()).subscribe({
            next: response => {
                this.snackBar.open(`Ports updated!`, 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.requestService.updateleaseRequestSubjectValue(response);
                setTimeout(() => {
                    // this.myOrderService.getRequestDetails();
                }, 1500);
                return response;
            },
            error: error => {
                this.requestObj.error = { ...error.error }
                console.log(error);
                return error;
            }
        })
    }

    getIdFromObjList() {
        return {
            pols: this.requestObj.pols.map((item) => item.id),
            pods: this.requestObj.pods.map((item) => item.id),
            delete_missing_locations: true,
        }
    }

    getLocationLabel(request) {
        switch (request.request_type.dev_name) {
            case 'one_way':
                this.superLocationSourceLabel = 'Pick-up Location*';
                this.superLocationDestinationLabel = 'Drop-off Location*';
                break;
            case 'buy_sell':
                if (request.transaction_type == 'use') {
                    this.superLocationSourceLabel = 'Buy Location*';
                } else {
                    this.superLocationSourceLabel = 'Sell Location*';
                }
                break;
            case 'lease':
                this.superLocationSourceLabel = 'On-hire Location*';
                this.superLocationDestinationLabel = 'Off-hire Location*';
                break;
        }
    }

    validatePorts() {
        if (this.requestObj.pols.length < 1) {
            this.requestObj.error.pols = ['Please select atleast one port'];
        }
        if (this.modelService.selectedRequest?.request_type?.dev_name != 'buy_sell') {
            if (this.requestObj.pods.length < 1) {
                this.requestObj.error.pods = ['Please select atleast one port'];
            }
        }
        return this.requestObj.error.pols.length == 0 && this.requestObj.error.pods.length == 0;
    }

    getLeasingPeriod(requirement) {
        return requirement.reduce((max, item) => (item.leasing_period_days > max ? item.leasing_period_days : max), requirement[0].leasing_period_days) + ' Days';
    }

    closeView() {
        this.close.emit();
    }
}